<nz-row>
  <nz-col [nzXl]="24" [nzLg]="24" [nzMd]="24" [nzSm]="24" [nzXs]="24"
  [ngClass]="parameter.FieldName + '_' + reportIdVal"
   *ngFor="let parameter of parameters">
    <nz-form-item *ngIf="parameter.Hidden != true">
      <nz-form-label nz-col [nzSpan]="8" [nzRequired]="parameter.Required" [nzFor]="parameter.FieldName">
        {{parameter.Label}}</nz-form-label>
      <nz-form-control nz-col [nzSpan]="16">
        <ng-container [ngSwitch]="parameter.DataType">
          <nz-select *ngSwitchCase="DataType.DropDown" nzShowSearch nzAllowClear [name]="parameter.FieldName"
            [id]="parameter.FieldName" [(ngModel)]="parametersValues[parameter.FieldName]"
            [nzFilterOption]="nzFilterOption" (nzOnSearch)="search(parameter, $event)">
            <nz-option *ngFor="let o of parameter.Options" [nzLabel]="o.text" [nzValue]="o.id"></nz-option>
          </nz-select>
          <nz-select *ngSwitchCase="DataType.MultiSelect" nzShowSearch nzAllowClear [name]="parameter.FieldName"
            nzMode="multiple" [id]="parameter.FieldName" [(ngModel)]="parametersValues[parameter.FieldName]"
            [nzFilterOption]="nzFilterOption" (nzOnSearch)="search(parameter, $event)">
            <nz-option *ngFor="let o of parameter.Options" [nzLabel]="o.text" [nzValue]="o.id"></nz-option>
          </nz-select>
          <nz-select *ngSwitchCase="DataType.BusinessPartnerProperties" nzShowSearch nzAllowClear
            [name]="parameter.FieldName" nzMode="multiple" [id]="parameter.FieldName"
            [(ngModel)]="parametersValues[parameter.FieldName]" [nzFilterOption]="nzFilterOption"
            (nzOnSearch)="search(parameter, $event)">
            <nz-option *ngFor="let o of parameter.Options" [nzLabel]="o.text" [nzValue]="o.id"></nz-option>
          </nz-select>
          <nz-select *ngSwitchCase="DataType.ItemProperties" nzShowSearch nzAllowClear [name]="parameter.FieldName"
            nzMode="multiple" [id]="parameter.FieldName" [(ngModel)]="parametersValues[parameter.FieldName]"
            [nzFilterOption]="nzFilterOption" (nzOnSearch)="search(parameter, $event)">
            <nz-option *ngFor="let o of parameter.Options" [nzLabel]="o.text" [nzValue]="o.id"></nz-option>
          </nz-select>
          <input *ngSwitchCase="DataType.Field" nz-input [name]="parameter.FieldName" [id]="parameter.FieldName"
            [(ngModel)]="parametersValues[parameter.FieldName]" />
          <nz-input-number *ngSwitchCase="DataType.Number" nz-input [name]="parameter.FieldName" [id]="parameter.FieldName"
            [(ngModel)]="parametersValues[parameter.FieldName]"></nz-input-number>
          <ng-container *ngSwitchCase="DataType.Date">
            <nz-date-picker [(ngModel)]="parametersValues[parameter.FieldName]" [ngModelOptions]="{ updateOn: 'blur'}"
              [nzDateRender]="tplRender" [nzFormat]="dateFormat">
            </nz-date-picker>
            <ng-template #tplRender let-current>
              <div class="ant-picker-cell-inner" [class.border]="current.getDate() === 1">
                {{ current.getDate() }}
              </div>
            </ng-template>
          </ng-container>
        </ng-container>
      </nz-form-control>
    </nz-form-item>
  </nz-col>
</nz-row>
